"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_STATES_BY_REGION_ID = exports.SUPPORTED_STATES_BY_CODE = exports.SUPPORTED_STATES = void 0;
// Note that regionId is the API (American Petroleum Institute) state code for the state.
exports.SUPPORTED_STATES = [
    { code: 'KY', name: 'Kentucky', regionId: 16 },
    { code: 'LA', name: 'Louisiana', regionId: 17, countyOrParish: 'Parish', countyOrParishPlural: 'Parishes' },
    { code: 'NY', name: 'New York', regionId: 31 },
    { code: 'OH', name: 'Ohio', regionId: 34 },
    {
        code: 'PA',
        name: 'Pennsylvania',
        regionId: 37,
        transfersDisclaimer: 'The relevant state agency does not publish transfer records publicly.',
    },
    {
        code: 'TN',
        name: 'Tennessee',
        regionId: 41,
        transfersDisclaimer: 'The relevant state agency does not publish transfer records publicly.',
    },
    { code: 'VA', name: 'Virginia', regionId: 45 },
    { code: 'WV', name: 'West Virginia', regionId: 47 },
    { code: 'NM', name: 'New Mexico', regionId: 30 },
];
exports.SUPPORTED_STATES_BY_CODE = exports.SUPPORTED_STATES.reduce((a, c) => {
    // @ts-ignore
    a[c.code] = c;
    return a;
}, {});
exports.SUPPORTED_STATES_BY_REGION_ID = exports.SUPPORTED_STATES.reduce((a, c) => {
    // @ts-ignore
    a[c.regionId] = c;
    return a;
}, {});
//# sourceMappingURL=supportedStates.js.map